import { MAX_DISCOUNT_PERCENTAGE_BASE } from 'Data/case-closer.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return MAX_DISCOUNT_PERCENTAGE_BASE
}
